declare const I18n;

import React from "react";
import SkillHeading from "./Heading";
import WomenInStemCard from "./WomenInStemCard";
import RankBadge from "../overallrank/RankBadge";

type SkillsContainerProps = {
  skill: any;
  filteredBadges: any;
};

const SkillsContainer: React.FC<SkillsContainerProps> = ({ skill, filteredBadges }) => {
  const sortedBadges = filteredBadges
    .slice()
    .sort((a, b) => a.pointsRequired - b.pointsRequired);

  const lockedIndex = sortedBadges.findIndex(badge => !badge.unlocked)

  return (
    <div className="skills-container">
      <SkillHeading skillSlug={skill.slug} />

      <div className="skills-grid">
        {sortedBadges.map((badge, index) => {
          return (
            <WomenInStemCard
              key={badge.id}
              name={badge.name}
              skillSlug={skill.slug}
              unlocked={badge.unlocked}
              isNew={false}
              currentPoints={badge.currentPoints}
              pointsRequired={badge.pointsRequired}
              info={badge.description}
              imageUrl={badge.file_url}
              showProgress={index === lockedIndex}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SkillsContainer;
